import { useDispatch, useSelector } from "react-redux";
import "../../Static Files/styles/Manage Tours/managetours.css";
import TourModal from "../../Components/addModalForTour";
import { useEffect, useState } from "react";
import ImageModal from "../../Components/addImageModal";
import {
  fetchTours,
  fetchDiscountTours,
  fetchSpecialOfferTours,
  fetchImagesFromGallery,
  deleteTour,
  fetchAllInActiveTours,
  deleteAllInActiveTours,
  changeStatus,
  fetchPrivateTours,
} from "../../slices/tourSlice";
import TourDetailAdmin from "../../Components/tourDetailsAdmin";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
import CategoryModal from "../../Components/addCategoryModal";
import Success from "../../Components/success";
import HotelModal from "../../Components/addHotelModal";

const ManageTours = () => {
  const dispatch = useDispatch();
  const {
    tours,
    privateTours,
    images,
    specialOfferTours,
    discountTours,
    inActiveTours,
    status,
  } = useSelector((state) => state.tours);
  const [importedTours, setImportedTours] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHotelModalOpen, setIsHotelModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [imageModalOpen, setImageModal] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedTour, setSelectedTour] = useState(null);
  const [selectedTourId, setId] = useState();

  useEffect(() => {
    dispatch(fetchTours());
    setImportedTours(tours);
  }, [dispatch]);

  const allTours = () => {
    dispatch(fetchTours());
    setImportedTours(tours);
  };
  const allPrivateTours = () => {
    dispatch(fetchPrivateTours());
    setImportedTours(privateTours);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openHotelModal = (tour) => {
    setSelectedTour(tour);
    setIsHotelModalOpen(true);
  };

  const categoryOpenModal = () => {
    setIsCategoryModalOpen(true);
  };

  const categoryCloseModal = () => {
    setIsCategoryModalOpen(false);
  };

  const allSpecialTours = () => {
    dispatch(fetchSpecialOfferTours());
    setImportedTours(specialOfferTours);
  };

  const allDiscountTours = () => {
    dispatch(fetchDiscountTours());
    setImportedTours(discountTours);
  };

  const allInActiveTours = () => {
    var response = dispatch(fetchAllInActiveTours());
    setImportedTours(inActiveTours);
  };
  const openImageModal = (tour) => {
    setDetailOpen(false);
    setSelectedTour(tour);
    setImageModal(true);
  };

  const openDetail = (tour) => {
    setSelectedTour(tour);
    setDetailOpen(true);
  };

  const deleteInActiveTours = async () => {
    var response = await dispatch(deleteAllInActiveTours());
    if (status === "succeeded") {
      setIsSuccess(true);
    }
  };

  const changeStatusTour = async (id) => {
    setDetailOpen(false);
    var response = await dispatch(changeStatus(id));
    if (status === "succeeded") {
      setIsSuccess(true);
    }
  };

  const remove = (tourId) => {
    setDetailOpen(false);
    dispatch(deleteTour(tourId));
    dispatch(fetchTours());
    setImportedTours(tours);
  };

  return (
    <section className="tours-section">
      <div className="top">
        <ul className="users-card-list">
          <li>
            <a href="#" onClick={() => allTours()}>
              Bütün turlar
            </a>
          </li>
          <li>
            <a href="#" onClick={() => allPrivateTours()}>
              Şəxsi turlar
            </a>
          </li>
          <li>
            <a href="#" onClick={() => allDiscountTours()}>
              Endirimli turlar
            </a>
          </li>
          <li>
            <a href="#" onClick={() => allInActiveTours()}>
              Aktiv olmayan turlar
            </a>
          </li>
          <li>
            <a href="#" onClick={() => allSpecialTours()}>
              Xüsusi Təkliflər
            </a>
          </li>
        </ul>
        <ul className="operation">
          <li>
            <a href="#" onClick={() => deleteInActiveTours()}>
              Aktiv olmayanları sil
            </a>
          </li>
          <li>
            <a href="#" onClick={() => categoryOpenModal()}>
              Kateqoriya yarat
            </a>
          </li>
          <li>
            <a href="#" onClick={() => openModal()}>
              Tur yarat
            </a>
          </li>
        </ul>
      </div>

      <table className="tab-tours">
        <thead>
          <tr>
            <th>ID</th>
            <th>Başlıq</th>
            <th>Ölkələr</th>
            <th>Qiymət</th>
            <th>Status</th>
            <th>Tip</th>
            <th>İstək sayı</th>
            <th>Əməliyyatlar</th>
          </tr>
        </thead>
        <tbody>
          {importedTours.map((tour) => (
            <tr key={tour.id}>
              <td onClick={() => openDetail(tour)} className="id-tr">
                {tour.id}
              </td>
              <td>{tour.title}</td>
              <td>
                {tour.isMultipleTour === true ? tour.countries : tour.country}
              </td>
              <td>{tour.price}</td>
              <td>{tour.status}</td>
              {tour.isPrivate === true ? (
                <td>Şəxsi tur</td>
              ) : (
                <td>Qlobal tur</td>
              )}
              <td style={{ paddingLeft: "4vw" }}>{tour.requestCount}</td>
              <td>
                <button
                  className="operation-button"
                  onClick={() => openImageModal(tour)} // Butona tıklandığında modal açılır
                >
                  Şəkil əlavə et
                </button>
                <button
                  className="operation-button"
                  onClick={() => openHotelModal(tour)} // Butona tıklandığında modal açılır
                >
                  Otel əlavə et
                </button>
                <button
                  className="operation-button"
                  onClick={() => changeStatusTour(tour.id)} // Butona tıklandığında modal açılır
                >
                  Statusunu dəyiş
                </button>
                <button
                  onClick={() => remove(tour.id)}
                  className="operation-button"
                >
                  🗑️ Sil
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {imageModalOpen && (
        <ImageModal
          isOpen={imageModalOpen}
          onClose={() => setImageModal(false)}
          selectedTour={selectedTour}
        />
      )}

      {isSuccess && (
        <Success isOpen={isSuccess} onClose={() => setIsSuccess(false)} />
      )}

      {isModalOpen && (
        <TourModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      )}

      {isHotelModalOpen && (
        <HotelModal
          isOpen={isHotelModalOpen}
          onClose={() => setIsHotelModalOpen(false)}
          selectedTour={selectedTour}
        />
      )}

      {isCategoryModalOpen && (
        <CategoryModal
          isOpen={isCategoryModalOpen}
          onClose={() => setIsCategoryModalOpen(false)}
        />
      )}

      {detailOpen && (
        <TourDetailAdmin
          isOpen={detailOpen}
          onClose={() => setDetailOpen(false)}
          tour={selectedTour}
        />
      )}
    </section>
  );
};
export default ManageTours;
